import { colors } from "../../Styles";

export function Search({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <rect x="145.9" y="190.46" width="137.17" height="39.51" rx="8.03" ry="8.03" transform="translate(211.47 -90.09) rotate(45)"/>
      <path d="M174.89,82.4c-5.8-43.05-45.4-73.26-88.45-67.46C43.39,20.74,13.19,60.34,18.98,103.39c5.8,43.05,45.4,73.26,88.45,67.46,14.3-1.92,27.18-7.58,37.79-15.85l13.07,12.99,14.73-14.45-13.32-13.24c12.05-15.96,18.06-36.5,15.18-57.89ZM105.23,152.79c-33.08,4.45-63.5-18.75-67.95-51.83-4.45-33.08,18.75-63.5,51.83-67.95,33.08-4.45,63.5,18.75,67.95,51.83,4.45,33.08-18.75,63.5-51.83,67.95Z"/>
      <path d="M50.78,93.41s3.79-45.29,47.04-43.75c0,0-28.47,0-47.04,43.75Z"/>
    </svg>
  );
}